import Axios from 'axios';
import { APP_CONFIG } from '@/common';
import { PrecisePriceConfig } from '@/entities/config';

export abstract class GatewayAbstractService {
	gatewayServices = Axios.create({
		baseURL: `${APP_CONFIG.GATEWAY_URL}services/`,
	});

	constructor({ apiKey, ppSSOKey }: PrecisePriceConfig) {
		this.gatewayServices.defaults.headers['X-Api-Key'] = apiKey;
		this.gatewayServices.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
		if (ppSSOKey !== undefined) {
			this.gatewayServices.defaults.headers['X-Pp-Key'] = ppSSOKey;
		}
	}
}
